import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "calculator__branch" }
const _hoisted_2 = {
  key: 0,
  class: "calculator__hotkeys-block tooltip-anchor--no-relative"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "При нажатии по иконке скилла:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "hotkey" }, "ЛКМ"),
  /*#__PURE__*/_createTextVNode(" - повысить уровень на 1")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "hotkey" }, "ПКМ"),
  /*#__PURE__*/_createTextVNode(" - понизить уровень на 1")
], -1)
const _hoisted_6 = { class: "calculator__title-block" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "calculator__remaining-stats" }
const _hoisted_9 = { class: "calculator__branch-perk-description-wrapper" }
const _hoisted_10 = { class: "calculator__branch-perk-description" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "calculator__separator" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "calculator__separator" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "calculator__separator" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconQuestionCircle = _resolveComponent("IconQuestionCircle")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_TooltipComponent = _resolveComponent("TooltipComponent")!
  const _component_calculator_tier = _resolveComponent("calculator-tier")!
  const _component_calculator_restriction = _resolveComponent("calculator-restriction")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.branchIndex === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_IconBase, null, {
            default: _withCtx(() => [
              _createVNode(_component_IconQuestionCircle)
            ]),
            _: 1
          }),
          _createVNode(_component_TooltipComponent, {
            direction: 'right',
            width: 30,
            color: 'dark'
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("img", {
        src: require(`@/assets/stat_icons/${_ctx.statIconLink}`),
        alt: "",
        class: "calculator__icon"
      }, null, 8, _hoisted_7),
      _createElementVNode("h2", _hoisted_8, [
        _createElementVNode("span", null, _toDisplayString(_ctx.remainingStats[_ctx.branchIndex]), 1),
        _createTextVNode(" / "),
        _createElementVNode("span", null, _toDisplayString(_ctx.statsPool[_ctx.branchIndex]), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.getBranchPerkDescription(_ctx.branchIndex)) + " ", 1),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.classBasedOnIndex)
          }, _toDisplayString(_ctx.getBranchPerkAmount(_ctx.branchIndex, _ctx.statsPool[_ctx.branchIndex])), 3)
        ])
      ])
    ]),
    _hoisted_11,
    _createVNode(_component_calculator_tier, {
      tierSkills: _ctx.skills.tier1,
      tags: _ctx.tags,
      branchColor: _ctx.classBasedOnIndex,
      branchIndex: _ctx.branchIndex,
      branchTier: 'tier1',
      branchRemainingStats: _ctx.getRemainingStats(_ctx.branchIndex),
      soldierClass: _ctx.soldierClass,
      onStatChanged: _ctx.statChanged
    }, null, 8, ["tierSkills", "tags", "branchColor", "branchIndex", "branchRemainingStats", "soldierClass", "onStatChanged"]),
    _hoisted_12,
    _createElementVNode("div", {
      class: _normalizeClass(["calculator__restriction-block calculator__restriction-bg", { 'is-transparent': !_ctx.isHigherTiersBlocked() }])
    }, [
      _createVNode(_component_calculator_restriction, {
        isHigherTiersBlocked: _ctx.isHigherTiersBlocked(),
        howManyPointsToUnlock: _ctx.howManyPointsToUnlock()
      }, null, 8, ["isHigherTiersBlocked", "howManyPointsToUnlock"]),
      _createVNode(_component_calculator_tier, {
        tierSkills: _ctx.skills.tier2,
        tags: _ctx.tags,
        branchColor: _ctx.classBasedOnIndex,
        branchIndex: _ctx.branchIndex,
        branchTier: 'tier2',
        branchRemainingStats: _ctx.getRemainingStats(_ctx.branchIndex),
        soldierClass: _ctx.soldierClass,
        onStatChanged: _ctx.statChanged
      }, null, 8, ["tierSkills", "tags", "branchColor", "branchIndex", "branchRemainingStats", "soldierClass", "onStatChanged"]),
      _hoisted_13,
      _createVNode(_component_calculator_tier, {
        tierSkills: _ctx.skills.tier3,
        tags: _ctx.tags,
        branchColor: _ctx.classBasedOnIndex,
        branchIndex: _ctx.branchIndex,
        branchTier: 'tier3',
        branchRemainingStats: _ctx.getRemainingStats(_ctx.branchIndex),
        soldierClass: _ctx.soldierClass,
        onStatChanged: _ctx.statChanged
      }, null, 8, ["tierSkills", "tags", "branchColor", "branchIndex", "branchRemainingStats", "soldierClass", "onStatChanged"])
    ], 2)
  ]))
}